import {
  ClassificationValueAssignment,
  ClassificationValueInput,
} from "../models/classifications";
import { ProjectId } from "../types";
import { Endpoints } from "./constants";
import { AssetsHttpClient } from "./createAssetsHttpClient";

/**
 * Pure fetch logic for tagging/untagging acc-classifications nodes onto an Asset
 * (assets-api-server v3, ADASSETS-1412/1451). Mirrors `classificationStructureClient.ts`.
 *
 * Per-asset only — there is no cross-asset batch endpoint here, unlike `assets:batch-patch`.
 */
export const getClassificationValueClient = (
  http: AssetsHttpClient,
  projectId: ProjectId
) => ({
  batchAssignClassificationValues: (
    assetId: string,
    data: ClassificationValueInput[]
  ): Promise<ClassificationValueAssignment[]> =>
    http
      .post<{ results: ClassificationValueAssignment[] }>(
        `${http.getAssetsServiceBasePath(projectId, "v3")}/${
          Endpoints.Assets
        }/${assetId}/${Endpoints.ClassificationValues}:batch-assign`,
        { body: JSON.stringify({ data }) }
      )
      .then(({ results }) => results),

  // Returns 204 with no body. Idempotent — removing an unknown or already-removed value id is a
  // no-op server-side.
  removeClassificationValue: (
    assetId: string,
    classificationValueId: ClassificationValueAssignment["id"]
  ): Promise<void> =>
    http.del<void>(
      `${http.getAssetsServiceBasePath(projectId, "v3")}/${
        Endpoints.Assets
      }/${assetId}/${Endpoints.ClassificationValues}/${classificationValueId}`
    ),
});

export type ClassificationValueClient = ReturnType<
  typeof getClassificationValueClient
>;
